import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import styled from 'styled-components/native';
import { SccButton } from '@/components/atoms';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import BottomSheet from '@/modals/BottomSheet/BottomSheet';
import { Image } from 'react-native';
export default function PhotoConfirmBottomSheet({ isVisible, onConfirm, onCancel, }) {
    return (_jsx(BottomSheet, { isVisible: isVisible, onPressBackground: onCancel, children: _jsxs(ContentsContainer, { children: [_jsx(IconContainer, { children: _jsx(Image, { source: require('@/assets/img/camera.png'), style: {
                            width: 75,
                            height: 60,
                        } }) }), _jsx(Title, { children: "\uC815\uB9D0 \uC0AC\uC9C4 \uC5C6\uC774 \uB4F1\uB85D\uD560\uAE4C\uC694?" }), _jsxs(Description, { children: ['계단뿌셔클럽 간담회에서 휠체어 사용자의 ', _jsx(BoldText, { children: "95%" }), '가\n사진이 있을 때 훨씬 도움이 된다고 답했어요!'] }), _jsxs(ButtonContainer, { children: [_jsx(SccButton, { text: "\uADF8\uB0E5 \uB4F1\uB85D\uD558\uAE30", elementName: "photo_confirm_cancel_button", onPress: onCancel, buttonColor: "gray20", textColor: "gray70", fontFamily: font.pretendardMedium, height: 48, style: { flex: 1, borderRadius: 14 } }), _jsx(SccButton, { text: "\uC0AC\uC9C4 \uCD94\uAC00\uD558\uAE30", elementName: "photo_confirm_button", onPress: onConfirm, buttonColor: "brand40", textColor: "white", fontFamily: font.pretendardSemibold, height: 48, style: { flex: 1, borderRadius: 14 } })] })] }) }));
}
const ContentsContainer = styled.View({
    paddingTop: 20,
    paddingHorizontal: 20,
});
const IconContainer = styled.View({
    alignItems: 'center',
    paddingTop: 16,
    paddingBottom: 12,
});
const Title = styled.Text({
    fontSize: 20,
    fontFamily: font.pretendardBold,
    color: color.black,
    textAlign: 'center',
    lineHeight: 28,
    letterSpacing: -0.4,
});
const Description = styled.Text({
    fontSize: 16,
    fontFamily: font.pretendardRegular,
    color: color.gray70,
    lineHeight: 24,
    textAlign: 'center',
    marginTop: 5,
    marginBottom: 12,
});
const BoldText = styled.Text({
    fontFamily: font.pretendardBold,
});
const ButtonContainer = styled.View({
    flexDirection: 'row',
    gap: 10,
    paddingVertical: 12,
});
